<template>
  <div
      class="hidden relative sm:flex object-fill bg-slate-100 select-none max-h-[290px] sm:max-h-[331px] h-[28vh] md:h-[33vh] lg:h-[36vh] min-h-[270px]">
    <div v-show="isImageLoading" class="modal-loader z-[2] absolute inset-0 h-full w-full">
      <div class="lds-dual-ring"></div>
    </div>
    <NuxtImg
        draggable="false"
        class="w-full h-full block"
        :src="imageURL || defaultImg"
        height="331"
        width="970"
        loading="index === 0 ? 'eager' : 'lazy'"
        :alt="imageName"
        @error="handleImgError"
        @load="stopImageLoading"
        placeholder="blur"
    />
  </div>
</template>

<script>
import defaultImg from "@/assets/images/placeholder(doNotRemove).jpg";

export default {
  data() {
    return {
      defaultImg,
      isImageLoading: true,
    };
  },
  props: {
    imageURL: {
      type: String,
      required: true,
      default: "",
    },
    imageName: {
      type: String,
      required: true,
      default: "",
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    stopImageLoading() {
      this.isImageLoading = false;
    },
    handleImgError(e) {
      // Handle image error and fallback to default image
      this.stopImageLoading();
      e.target.src = this.defaultImg;
      e.onerror = null;
    },
  },
};
</script>

<style>
</style>
